
import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import withTranslator from '../Translator/withTranslation';

const Label = styled.div `
    position: absolute;
    z-index: 1;
    right: 15px;
    top: 15px;
    background: ${colors.orange1};
    padding: 0.5em 1em;
    font-weight: 600;
    text-transform: uppercase;
    color: #fff;
    border-radius: 0px 0px 0px 3px;
`;

const LabelMobile = styled.div `
    position: absolute;
    z-index: 1;
    background: ${colors.orange1};
    padding: 0.5em 1em;
    font-weight: 600;
    text-transform: uppercase;
    color: #fff;
    border-radius: 0px 0px 0px 3px;
    right: 0px;
    top: 0px;
`;

const VillaTileOpportunityComponent = (props) => { 
    const mobile = props.mobile;
    return mobile  ? 
            <LabelMobile>
                {props.t('opportunity')}
            </LabelMobile>
            : 
            <Label>
                {props.t('opportunity')}
            </Label>
}

export const VillaTileOpportunity = withTranslator(VillaTileOpportunityComponent);